module.exports = __webpack_public_path__ + "img/13.8da2d396.png";